import { IPoint } from '@src/slide/infrastructure/module/independent/graphic/point/point.interface';
import { distanceFromPointToSegment } from '@src/slide/infrastructure/module/independent/graphic/distance';

export class Polygon {
    public constructor(public vertices: IPoint[]) {}

    /**
     * 和另一个多边形之间的距离
     * @param polygon
     */
    public distanceToPolygon(polygon: Polygon): number {
        for (const p1 of this.vertices) {
            if (this.pointInPolygon(p1, polygon)) {
                return 0;
            }
        }

        for (const p2 of polygon.vertices) {
            if (this.pointInPolygon(p2, this)) {
                return 0;
            }
        }

        let minDistance = Infinity;

        for (let i = 0; i < this.vertices.length; i++) {
            const a1 = this.vertices[i];
            const b1 = this.vertices[(i + 1) % this.vertices.length];

            for (let j = 0; j < polygon.vertices.length; j++) {
                const a2 = polygon.vertices[j];
                const b2 = polygon.vertices[(j + 1) % polygon.vertices.length];

                const d1 = distanceFromPointToSegment(a1, a2, b2);
                const d2 = distanceFromPointToSegment(a2, a1, b1);

                minDistance = Math.min(minDistance, d1, d2);
            }
        }

        return minDistance;
    }

    public containPolygon(polygon: Polygon): boolean {
        for (const p of polygon.vertices) {
            if (!this.pointInPolygon(p, this)) {
                return false;
            }
        }
        return true;
    }

    public pointInPolygon(p: IPoint, polygon: Polygon): boolean {
        let inside = false;
        // eslint-disable-next-line no-plusplus
        for (let i = 0, j = polygon.vertices.length - 1; i < polygon.vertices.length; j = i++) {
            const xi = polygon.vertices[i].x;
            const yi = polygon.vertices[i].y;
            const xj = polygon.vertices[j].x;
            const yj = polygon.vertices[j].y;

            const intersect = (yi > p.y) !== (yj > p.y) && p.x < (((xj - xi) * (p.y - yi)) / (yj - yi)) + xi;

            if (intersect) {
                inside = !inside;
            }
        }
        return inside;
    }
}
